import moduleSelect from "./moduleSelect.container";

export default moduleSelect;
